declare let global: any;

if (typeof global === 'undefined') {
    (window as any).global = window;
}

export interface IReportSettings {
    reportServerUrl: string;
    reportViewUrl: string;
    reportDownloadUrl: string;
    reportFolder: string;
    drugShipmentForm: string;
}

const reportSettings: IReportSettings = global.REPORT_SETTINGS;

export default reportSettings;